import React, { FC } from "react";
// load more icon from here: https://material.io/resources/icons/?icon=keyboard_arrow_up&style=baseline

interface IconProps {
  src: any;
}

const Icon: FC<IconProps> = ({ src }) => {
  return <img src={src} alt="icon" />;
};

export default Icon;
